module.exports = __webpack_public_path__ + "e50c9d53292d7d222fd11a6f4f9dc6d2.png";